export const theme = {
  colors: {
    background: {
      day: '#0f0b1d',
      night: '#05030c',
      setup: '#080413',
    },
    text: {
      primary: '#f5f2ff',
      secondary: 'rgba(245, 242, 255, 0.75)',
      muted: 'rgba(245, 242, 255, 0.65)',
    },
    border: {
      primary: 'rgba(124, 93, 255, 0.22)',
      secondary: 'rgba(255, 255, 255, 0.18)',
      strong: 'rgba(124, 93, 255, 0.55)',
    },
    card: {
      background: 'rgba(18, 12, 36, 0.94)',
      backgroundAlt: 'rgba(12, 8, 26, 0.94)',
      instruction: 'rgba(255, 196, 0, 0.12)',
      instructionBorder: 'rgba(255, 196, 0, 0.38)',
      success: 'rgba(68, 255, 210, 0.12)',
      successBorder: 'rgba(68, 255, 210, 0.32)',
      error: 'rgba(255, 77, 109, 0.18)',
      errorBorder: 'rgba(255, 77, 109, 0.45)',
      meta: 'rgba(255, 255, 255, 0.05)',
      metaBorder: 'rgba(255, 255, 255, 0.12)',
    },
    button: {
      primary: 'linear-gradient(135deg, rgba(124, 93, 255, 0.95), rgba(70, 46, 150, 0.95))',
      primaryHover: 'linear-gradient(135deg, rgba(134, 103, 255, 0.95), rgba(80, 56, 160, 0.95))',
      secondary: 'rgba(255, 255, 255, 0.08)',
      secondaryHover: 'rgba(255, 255, 255, 0.16)',
      danger: 'linear-gradient(135deg, rgba(255, 96, 122, 0.95), rgba(214, 38, 78, 0.95))',
      dangerHover: 'linear-gradient(135deg, rgba(255, 106, 132, 0.95), rgba(224, 48, 88, 0.95))',
    },
    role: {
      mafia: {
        bg: 'rgba(255, 112, 112, 0.16)',
        border: 'rgba(255, 112, 112, 0.38)',
        text: '#ffc9c9',
      },
      don: {
        bg: 'rgba(124, 93, 255, 0.16)',
        border: 'rgba(124, 93, 255, 0.42)',
        text: '#d6d0ff',
      },
      sheriff: {
        bg: 'rgba(255, 196, 0, 0.16)',
        border: 'rgba(255, 196, 0, 0.42)',
        text: '#ffe8a6',
      },
      citizen: {
        bg: 'rgba(0, 186, 255, 0.16)',
        border: 'rgba(0, 186, 255, 0.45)',
        text: '#bde9ff',
      },
    },
  },
  borderRadius: {
    sm: '12px',
    md: '16px',
    lg: '18px',
    xl: '22px',
    xxl: '26px',
    round: '999px',
  },
  spacing: {
    xs: '0.5rem',
    sm: '0.75rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
  },
  shadows: {
    sm: '0 12px 32px rgba(10, 6, 25, 0.25)',
    md: '0 16px 48px rgba(10, 6, 25, 0.35)',
    lg: '0 20px 60px rgba(10, 6, 25, 0.45)',
    xl: '0 28px 90px rgba(4, 2, 14, 0.65)',
    button: '0 14px 36px rgba(124, 93, 255, 0.32)',
    buttonHover: '0 18px 42px rgba(124, 93, 255, 0.42)',
  },
  transitions: {
    fast: '0.15s ease',
    normal: '0.2s ease',
    slow: '0.3s ease',
  },
  breakpoints: {
    mobile: '768px',
    tablet: '992px',
    desktop: '1200px',
  },
};

export type Theme = typeof theme;
